import { Injectable } from '@angular/core';

import { DataEntry } from '@osos/shared/api';
import { TimelinePostPresenterModel } from '@osos/shared/types';
import { ParserBase } from '../../bases/parser/parser-base';

@Injectable({
  providedIn: 'root',
})
export class TimelinePostV1ParserService extends ParserBase<
  DataEntry,
  TimelinePostPresenterModel
> {
  constructor() {
    super(DataEntry, TimelinePostPresenterModel, 1);
  }
  getPresenterModel(model: Partial<DataEntry>): TimelinePostPresenterModel {
    return {
      specificationVersion: this.version,
      id: model.id,
      dataEntity: 'POSTS',
      value: {
        ...model.value,
        publishInfo: !model.value?.publishInfo ? {} : model.value.publishInfo,
        unpublishInfo: !model.value?.unpublishInfo
          ? {}
          : model.value.unpublishInfo,
      },
      state: model.state,
      creationInfo: model.creationInfo,
      updateInfo: model.updateInfo,
      entityVersion: model.entityVersion ?? 0,
      isEntryObsolete: model.invalidReason === 0,
      isEntryInvalid: model.invalidReason === 1,
    };
  }
  getDataModel(presenter: TimelinePostPresenterModel): DataEntry {
    throw new Error('Method not implemented.');
  }
}
